import { render, staticRenderFns } from "./OffersCards.vue?vue&type=template&id=7799e4bd&"
import script from "./OffersCards.vue?vue&type=script&lang=js&"
export * from "./OffersCards.vue?vue&type=script&lang=js&"
import style0 from "./OffersCards.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports